var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item',{attrs:{"two-line":""}},[_c('v-list-item-avatar',[_c('img',{attrs:{"src":"https://cdn2.iconfinder.com/data/icons/hacker-solid/100/hacker_hacker_human_-512.png"}})]),_c('v-list-item-content',[_c('v-list-item-title',[_vm._v(_vm._s(_vm.user.username))]),_c('v-list-item-subtitle',[_vm._v(_vm._s(_vm.$t("sidebar.loggedin")))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }